export default "__VITE_ASSET__DEoJWuHL__"